import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';

const AdsterraAd = ({ adKey = 'be7dedbe5d1d341393c334ba9657d8a2' }) => {
  const containerRef = useRef(null);
  const scriptsLoadedRef = useRef(false);

  useEffect(() => {
    if (containerRef.current && !scriptsLoadedRef.current) {
      scriptsLoadedRef.current = true;

      // Create config script
      const configScript = document.createElement('script');
      configScript.type = 'text/javascript';
      configScript.innerHTML = `
        atOptions = {
          'key' : '${adKey}',
          'format' : 'iframe',
          'height' : 90,
          'width' : 728,
          'params' : {}
        };
      `;
      containerRef.current.appendChild(configScript);

      // Create invoke script
      const invokeScript = document.createElement('script');
      invokeScript.type = 'text/javascript';
      invokeScript.src = `//www.highperformanceformat.com/${adKey}/invoke.js`;
      containerRef.current.appendChild(invokeScript);
    }

    // Cleanup function
    return () => {
      if (containerRef.current) {
        containerRef.current.innerHTML = '';
      }
      scriptsLoadedRef.current = false;
    };
  }, [adKey]);

  return (
    <Box
      ref={containerRef}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100px',
        width: '100%',
      }}
    />
  );
};

export default AdsterraAd;
